/* eslint-disable */
function Dialog(dialog) {
    const btn_close = dialog.querySelector(".btn-close");
    const elements = dialog.querySelectorAll('button, [href], input, summary ,select, textarea');
    const first = elements[0];
    const clicktouch = "ontouchstart" in document.documentElement ? 'touchstart' : 'click';
    const clickOut = e => {
        if(!dialog.querySelector(".dialog-box").contains(e.target)){
            dialog.close()
        }
    };

    let last = elements[elements.length - 1];

    const handleTabKeyPress = e => {
        if (e.key === 'Tab') {
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }

        if (e.key === 'Escape') {
            setIsOpen(false);
        }
    };

    dialog.addEventListener('keydown', handleTabKeyPress);

    btn_close.onclick = () => {
        dialog.close();
        window.removeEventListener(clicktouch, clickOut);
    }

    this.open = () => {
        dialog.showModal();
        window.addEventListener(clicktouch, clickOut, true);
    }

    this.reset = el => {
        last = el ? el : elements[elements.length - 1];;
    }
}

export default Dialog;